module.exports = __webpack_public_path__ + "09_mole.401c0e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer2/09_mole.png
// module id = lPTX
// module chunks = 0